import { Progress, ProgressProps } from '@mantine/core'

type UsageProgressBarProps = ProgressProps & {
  isFull?: boolean
}

export const UsageProgressBar = ({
  isFull,
  ...props
}: UsageProgressBarProps) => {
  return (
    <Progress
      radius="xs"
      {...props}
      color={isFull ? 'yellow' : 'brand-primary.6'}
      styles={(theme) => ({
        root: {
          backgroundColor: theme.colors['brand-primary'][0]
        }
      })}
    />
  )
}
